import type { BaseKeyFunction } from "../../../../../../lib/types/baseKeyFunction";

export type KeyCommunityAssignmentCompletionsProps = {
  assignmentId: number;
  classId: number;
  search?: string;
};

export const keyCommunityAssignmentCompletions: BaseKeyFunction<
  KeyCommunityAssignmentCompletionsProps
> = ({ assignmentId, classId, search }) => [
  "community-assignment-completions",
  classId.toString(),
  assignmentId.toString(),
  search,
];
